import { settingsService } from "Dashboard/services/settings.service";
import { useEffect, useState } from "react";

export function useMemorandumLogo() {
  const [memorandumLogo, setMemorandumLogo] = useState<string | null>(null);

  useEffect(() => {
    async function getLogo() {
      try {
        let logo = await settingsService.getMemorandumLogo();
        setMemorandumLogo(logo);
      } catch (err) {
        console.log(err);
      }
    }
    getLogo();
  }, []);

  return memorandumLogo;
}
